/* Sort */
/* -------------------------------------------------------------------------------------- */
function selectSort(event) {
	event.preventDefault();
	var element = document.getElementById("sort-by-select");
	element.classList.toggle("active");
	var element = document.getElementById("sort-by-select-mobile");
	element.classList.toggle("active");
}

function selectSortItems(event, item) {
	event.preventDefault();
	const select = document.querySelector('.SortByMobile:checked');
	select.value = item;
	document.getElementById(item).checked = true;
	var event = document.createEvent('Event');
	event.initEvent('input', true, true);
	select.dispatchEvent(event);
}
function selectSortItemsMobile(event, item) {
	event.preventDefault();
	const select = document.querySelector('.SortByMobile:checked');
	select.value = item;
	document.getElementById(item).checked = true;
	var event = document.createEvent('Event');
	event.initEvent('input', true, true);
	select.dispatchEvent(event);

}
/* Menu Scroll */
/* -------------------------------------------------------------------------------------- */
function navBarMiddle(scrollPos, positionNavBar, positionCollections) {
	var navbar = document.querySelector('.facets--bar');
	var navbarHeight = document.querySelector('.facets--bar').offsetHeight;
	var headerHeight = document.getElementById('header').offsetHeight -1;
	var footer = document.getElementById('footer');
	if (positionCollections != 0) {
		var minY = positionCollections - headerHeight;
	}else{
		var minY = positionNavBar - headerHeight;
	}
	var maxY = footer.offsetTop - navbarHeight - headerHeight;
	/* Set class for NAVBAR */
	if (scrollPos >= minY) {
		if (scrollPos <= maxY) {
			navbar.classList.add("sticky");
			if (positionCollections != 0) {	
				var collectionHeight = document.querySelector('.collection-banner--subcollections').offsetHeight	
				navbar.style.top = headerHeight + collectionHeight + "px";
			}else{
				navbar.style.top = headerHeight + "px";
			}
		}
	}else {
		navbar.classList.remove("sticky");
	}
	/* Set class for COLLECTION */
	if (positionCollections != 0){
		var navCollection = document.querySelector('.collection-banner--subcollections');
		var navCollectionHeight = document.querySelector('.collection-banner--subcollections').offsetHeight;
		var minY2 = positionCollections - headerHeight;
		var maxY2 = footer.offsetTop - navCollectionHeight - headerHeight;
		if (scrollPos >= minY2) {
			if (scrollPos <= maxY2) {
				navCollection.classList.add("sticky");			
			}
		}else {
			navCollection.classList.remove("sticky");
		}
	}
}
var positionNavBar = document.querySelector('.facets--bar').offsetTop + document.querySelector('.facets--bar').offsetHeight;
var subCollection = document.querySelector('.collection-banner--subcollections');
if (subCollection != null ) {
	var positionCollections = document.querySelector('.collection-banner--subcollections').offsetTop + document.querySelector('.collection-banner--subcollections').offsetHeight;
}else {
	var positionCollections = 0;
}
window.addEventListener('scroll', () => {
	lastKnownScrollPosition = window.scrollY;
	navBarMiddle(lastKnownScrollPosition, positionNavBar, 0);
});
